<template>
  <div class="min-h-screen bg-neutral-25">

    <!-- Mobile Tabs (Poziom, Moje dane, Zamówienia) -->
    <div class="flex bg-white border-b border-neutral-100 overflow-x-auto md:hidden">
      <RouterLink 
        to="/customer/level"
        class="flex-1 px-4 py-3 text-sm font-bold text-center whitespace-nowrap transition-colors"
        :class="isActive('/customer/level') ? 'text-neutral-950 border-b-2 border-primary-500' : 'text-neutral-600'"
      >
        Poziom
      </RouterLink>
      <RouterLink 
        to="/customer/profile"
        class="flex-1 px-4 py-3 text-sm font-bold text-center whitespace-nowrap transition-colors"
        :class="isActive('/customer/profile') ? 'text-neutral-950 border-b-2 border-primary-500' : 'text-neutral-600'"
      >
        Moje dane
      </RouterLink>
      <RouterLink 
        to="/customer/orders"
        class="flex-1 px-4 py-3 text-sm font-bold text-center whitespace-nowrap transition-colors"
        :class="isActive('/customer/orders') ? 'text-neutral-950 border-b-2 border-primary-500' : 'text-neutral-600'"
      >
        Zamówienia
      </RouterLink>
    </div>

    <!-- Main Layout -->
    <div class="flex">
      <!-- Sidebar - tylko desktop -->
      <CustomerSidebar class="hidden md:block" />
      
      <!-- Content -->
      <main class="flex-1">
        <RouterView />
      </main>
    </div>
  </div>
</template>

<script setup>
import { RouterView, RouterLink, useRoute } from 'vue-router';
import CustomerSidebar from '../components/customer/CustomerSidebar.vue';

const route = useRoute();

const isActive = (path) => {
  return route.path === path || 
         (path === '/customer/level' && route.path === '/customer');
};
</script>
